export const ROLE_KEY = 'role'
export const ASSET_TOKEN_SESSION_STORAGE_KEY = 'ATSSK'
export const ASSET_TOKEN_EXPIRES_STORAGE_KEY = 'ATESK'
export const REFRESH_TOKEN_SESSION_STORAGE_KEY = 'RTSSK'
export const REFRESH_TOKEN_EXPIRES_STORAGE_KEY = 'RTESK'
export const USER_ID_SESSION_STORAGE_KEY = 'UID'